export default __webpack_public_path__ + "static/media/crossroads13.69e2e827.webp";